import { useState } from "react";
import robot_guy from "../../resources/extras/animatedTalkingRobot.gif";

enum ComponentStates {
  RulesPage,
  LazerTagRules,
  CaptureTheFlagRules
}

const RulesPage = (): JSX.Element => {
  const [componentState, setComponentState] = useState(ComponentStates.RulesPage);

  switch (componentState) {
    case ComponentStates.RulesPage:
      return (
          <div className=""> 

          <div className="rule-manual">
            <div className="rules-title">
              <p></p>
            </div>
            <div className="rules-box">
              <p></p>
            <div className="rules-text">
              <ul>
                <li>Signal jamming or external interference with the controllers or IR is not allowed and will result in disqualification.</li>
                <li>Robots can attempt to block shots, attacks, or steal the ball but cannot intentionally flip or disable opponents.</li>
                <li>Humans controlling the robots cannot manually interfere with game-play once a match begins.</li>
                <li>Excessive ramming, flipping, or disabling opponents results in a penalty.</li>
              </ul>
            </div>
              <div className="button_placement">
                <button onClick={() => setComponentState(ComponentStates.LazerTagRules)} className="button_text">Lazer Tag</button>
                <button onClick={() => setComponentState(ComponentStates.CaptureTheFlagRules)} className="button_text">Capture The Flag</button>
              </div>
            
            </div>
            <img src={robot_guy} alt="Robot" className="robot-guy" />
          </div>
        </div>
      );

      case ComponentStates.LazerTagRules:
        return (
          <div className=""> 
          <button onClick={() => setComponentState(ComponentStates.RulesPage)} className="backButton"></button>
          <div className="rule-manual">
            <div className="rules-title">
              <p></p>
            </div>
            <div className="rules-box">
              <p></p>
            <div className="rules-text">
                <ul>
                  <li>Player V Player</li>
                  <li>Each hit is 500 pts</li>
                  <li>At the start of each game, every robot will start at a different corner</li>
                  <li>If a robot leaves the field, it will take a 5-second penalty before being allowed back in the game</li>
                </ul>
            </div>
            </div>
            <img src={robot_guy} alt="Robot" className="robot-guy" />
          </div>
        </div>
      );
      

    case ComponentStates.CaptureTheFlagRules:
      return (
        <div className=""> 
        <button onClick={() => setComponentState(ComponentStates.RulesPage)} className="backButton"></button>
        <div className="rule-manual">
          <div className="rules-title">
            <p></p>
          </div>
          <div className="rules-box">
            <p></p>
          <div className="rules-text">
          <ul>
                  <li>Team V Team</li>
                  <li>Each hit goal is a point</li>
                  <li>The ball must fully crossover the goal line to count as a goal</li>
                  <li>At the start of each game the ball should be placed in the middle for a kickoff.</li>
                  <li>If the ball leaves the play area, it is reset via a throw-in, goal kick, or corner kick.</li>
                  <li>Humans controlling the robots cannot manually interfere with game-play once a match begins.</li>
                </ul>
          </div>
          </div>
          <img src={robot_guy} alt="Robot" className="robot-guy" />
        </div>
      </div>
    );

    default:
      return <div>Error: Invalid state</div>;
  }
};

export default RulesPage;
